import { artifactName, artifactId } from '../../server/utils/artifactInfo';

export const PANORAMA_COMPONENT_ID = artifactName;
export const PANORAMA_FULL_ARTIFACT_ID = artifactId;
